'use es6';

import PropTypes from 'prop-types';
import { List } from 'foundations-components/transitional/components/List';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import styled from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
const QuestionTitle = styled.span.withConfig({
  displayName: "QuestionAnswerList__QuestionTitle"
})(["font-weight:500;"]);
const QuestionAnswerList = ({
  answers,
  disabled = false,
  multipleSelection,
  selectedAnswerIds,
  onSelectAnswer
}) => /*#__PURE__*/_jsx(List, {
  childStyles: {
    marginBlockEnd: '200'
  },
  "data-test-id": "question-answer-list",
  wrapChildren: true,
  children: answers.map(answer => {
    const answerId = answer.id;
    return /*#__PURE__*/_jsx(SelectableButton, {
      block: true,
      "data-test-id": "quiz-radio-option",
      disabled: disabled,
      name: "quiz-options",
      onClick: (...partialArgs) => onSelectAnswer(answerId, ...partialArgs),
      selected: selectedAnswerIds.includes(answerId),
      title: /*#__PURE__*/_jsx(QuestionTitle, {
        children: answer.text
      }),
      truncatable: false,
      type: multipleSelection ? 'checkbox' : 'radio'
    }, answerId);
  })
});
QuestionAnswerList.propTypes = {
  answers: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  multipleSelection: PropTypes.bool,
  onSelectAnswer: PropTypes.func.isRequired,
  selectedAnswerIds: PropTypes.array.isRequired
};
export default QuestionAnswerList;